import styles from "./StudioRelationsList.module.scss";
import { ItemsList } from "../../../../common/components/itemsList/ItemsList";
import { Icon, IconType } from "../../../../common/icons/Icon";
import { useAddAdditionalLayoutButton } from "../../../../common/infrastructure/hooks/useAddAdditionalLayoutButton";
import { useApiQuery } from "../../../../common/infrastructure/hooks/useApiQuery";
import { endpointsMetadata } from "../../../../common/infrastructure/routes/endpointsMetadata";
import {
  getDefaultRoutePath,
  routePaths,
} from "../../../../common/infrastructure/routes/routePaths";
import { classNames } from "primereact/utils";
import { SkeletonItem } from "../../../../common/components/skeletons/SkeletonItem";
import { RenderWhen } from "../../../../common/infrastructure/components/RenderWhen";
import { useAppContext } from "../../../../AppContext";
import { Navigate } from "react-router-dom";

export const StudioRelationsList = () => {
  const { userStudios, currentUser } = useAppContext();

  useAddAdditionalLayoutButton({
    iconType: IconType.PlusIcon,
    href: routePaths.studioRelationsAdd,
  });

  // Redirect if user has only one studio
  if (userStudios.length <= 1) {
    return <Navigate to={getDefaultRoutePath(currentUser)} replace />;
  }

  const { data: studioRelationsResult, isLoading } = useApiQuery<
    IStudioRelationModel[]
  >({
    queryKey: [endpointsMetadata.studioRelations.getAllConnections],
    endpoint: endpointsMetadata.studioRelations.getAllConnections,
    globalIsLoading: false,
  });

  return (
    <ItemsList
      isLoading={isLoading}
      className={styles.root}
      title="Свързани обекти"
      noItemsText="Няма намерени резултати."
      itemTemplate={(item, index, _, className) => {
        return (
          <StudioRelationItem
            className={className}
            relation={item}
            key={index}
            isLoading={isLoading}
          />
        );
      }}
      items={studioRelationsResult ?? []}
      showItemsCount
      enableSearch
      fullHeight
    />
  );
};

interface IStudioRelationItemProps {
  className?: string;
  relation?: IStudioRelationModel;
  isLoading: boolean;
  actionButtons?: React.ReactNode;
}

const StudioRelationItem = ({
  className,
  relation,
  isLoading,
}: IStudioRelationItemProps) => {
  return (
    <div className={classNames(className, styles.item)}>
      <SkeletonItem
        isLoading={isLoading}
        value={<div className={styles.item_name}>{relation?.firstStudio}</div>}
      />

      <RenderWhen condition={!isLoading}>
        <div className={styles.item_arrows}>
          <RenderWhen condition={!!relation?.isMutual}>
            <Icon type={IconType.ArrowLeft} />
          </RenderWhen>
          <Icon type={IconType.ArrowRight} />
        </div>
      </RenderWhen>

      <SkeletonItem
        isLoading={isLoading}
        value={
          <div className={styles.item_name}>{relation?.connectedStudio}</div>
        }
      />
    </div>
  );
};
